import appConfigApi from './api/appConfigApi';
import todoApi from './api/todoApi';

const api = {
  appConfig: appConfigApi,
  todo: todoApi,
};

export default api;
